export enum ExistingVerticalCabling {
  Fiber,
  CAT5e_Or_CAT6,
  CAT3_Or_VVT,
  Red_White_Jumper,
  Flat_Cable,
  Other,
}
